import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup,EuiFlexItem,EuiSpacer} from '@elastic/eui';
import { Action } from '../../../components/Menus/interface';
import { Menu } from '../../../components/Menus';
import FiltrosMenu from '../../../components/Menus/filtros';
import { MaskLoad } from '../../../components/Layout';
interface Props {
  data: any;
  handleFilter(filtro: any): any;
  isLoading?:boolean;
}

const InformePartesSinAdjuntosScreen = (props: Props) => {
  const ref:any = useRef();
  //const {currentUser}:any = useUserSettings();
  const { data, handleFilter, isLoading } = props;

  const [filtro, setFiltro] = useState<any>(undefined)
  //let [selected, setSelected] = useState<any>([]);

  const filtrarPartes = () => {
    handleFilter(filtro)
  }

  const filtroInicial = (filtro:any)=>{
    setFiltro(filtro);
    handleFilter && handleFilter(filtro)
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onExport = () =>{
    ref && ref.current.onExport();
  }

  useEffect(()=> {
    if(filtro){
      filtrarPartes();
    }
  },[filtro])

  // const onSelected = (selection: any) => {
  //   setSelected([...selection])
  // }

  // const isDisabledBtnDesvalidar = useMemo(()=>{
  //   return (currentUser.perfil !== PERFILES.FISCAL || (filtro!==undefined && filtro.estado !== ESTADOS.FISCAL))
  // },[currentUser,filtro])

  // const selectedCount = useMemo(()=>{
  //   return (selected.length > 0 && !isDisabledBtnDesvalidar) ? `(${selected.length})` : ``
  // },[selected,isDisabledBtnDesvalidar])

  const Actions: Action[] = useMemo(()=>[
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    //{handle:()=>{},text:`Desvalidar${selectedCount}`,color:"primary",size:"s", isDisabled:isDisabledBtnDesvalidar},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false},
  ],[onFilterClear])

  const getView = () => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          //selected={selected}
          //onSelected={onSelected}
          menu={false}
          ref={ref}
        />
        <MaskLoad isLoading={isLoading}/>
      </>
    )
  }

  return(
    <>
    <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="s" alignItems="center" justifyContent="flexStart" >
          <FiltrosMenu selectorEstado filtroInicial = {filtroInicial} onChangeFilter={setFiltro}/>
          <Menu actions={Actions} className="actions"/>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
     <EuiSpacer size="m" />
     {getView()}
   </> 
  );

};

export default InformePartesSinAdjuntosScreen;
